import { render, staticRenderFns } from "./DynamicPixForm.vue?vue&type=template&id=6310dcbc"
import script from "./DynamicPixForm.vue?vue&type=script&lang=js"
export * from "./DynamicPixForm.vue?vue&type=script&lang=js"
import style0 from "./DynamicPixForm.vue?vue&type=style&index=0&id=6310dcbc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports